import { Flex, Progress, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { EvidenceProgress } from 'api/brokerCases/types';
import { getProgressPercent } from 'pages/EvidencePage/helpers';
import { TypedFormatMessageFn } from 'types/intl';

export interface IEvidenceItemProgressProps {
  progress: EvidenceProgress;
}

export const EvidenceItemProgress = ({ progress }: IEvidenceItemProgressProps) => {
  const { formatMessage }: { formatMessage: TypedFormatMessageFn } = useIntl();
  const { completedCount, totalCount } = progress;
  const percent = getProgressPercent(completedCount, totalCount);

  return (
    <Flex align='center' className='ml-auto gap-2'>
      <Typography.Text className='text-xs text-gray-500'>
        {formatMessage({ id: 'evidence.itemProgress.summary' }, { completedCount, totalCount })}
      </Typography.Text>
      <div className='relative h-6 w-6 shrink-0'>
        <Progress type='circle' percent={percent} size={24} strokeColor='#05DF72' format={() => null} />
      </div>
    </Flex>
  );
};
